package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Objective_reflection(
  public val id: String,
  public val objective_id: String,
  public val attempt: Long,
  public val text: String,
  public val missed_deadline: String?,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
